// extracted by mini-css-extract-plugin
export default {"BoardIndex":"BoardIndex_BoardIndex__w7j3I","Index":"BoardIndex_Index__3GGYA","CurIndex":"BoardIndex_CurIndex__hn7Ap"};